<div class="row" style="margin-top: 10px;">
  <div class="col-md-12 text-center" *ngIf="loading">
    <img style="width: 30px; padding-left: 2px; margin-top: -3px" src="/img/loading.gif" />
  </div>
  <div class="col-md-12" *ngIf="!loading">
    <p-table [value]="viewingParameters"
             selectionMode="single"
             [(selection)]="selectedAppointmentDetail"
             (onRowSelect)="selectedRow($event)"
             styleClass="appointmentLogTable table table-condensed table-fixed-header table-filter header-fixed appointmentDetailsTable"
              [style] = "{ 'font-family': 'Play, sans-serif;'}"
    >
      <ng-template pTemplate="header">
        <tr ngClass="header">
          <th style="height: 40px;" class="th-upper">Parameter</th>
          <th style="height: 40px;" class="th-upper" *ngIf="selectedEventLog">
            Selected Event
            <br/>
            <span style="font-size: 10px;" *ngIf="selectedTimeZone !== 'UTC'">
              {{selectedEventLog.timestamp | amDateFormat:'MM/DD/YYYY h:mm a'}}
            </span>
            <span style="font-size: 10px;" *ngIf="selectedTimeZone === 'UTC'">
              {{selectedEventLog.timestamp | amUtc | amDateFormat:'YYYY-MM-DD[T]HH:mm:ss[Z]'}}
            </span>
          </th>
          <th style="height: 40px;" class="th-upper" *ngIf="eventsForSelectedMessage">
            Selected Message
            <br/>
            <span style="font-size: 10px;" *ngIf="selectedTimeZone !== 'UTC'">
              {{eventsForSelectedMessage.reminderTimeMs | amDateFormat:'MM/DD/YYYY h:mm a'}}
            </span>
            <span style="font-size: 10px;" *ngIf="selectedTimeZone === 'UTC'">
              {{eventsForSelectedMessage.reminderTimeMs | amUtc | amDateFormat:'YYYY-MM-DD[T]HH:mm:ss[Z]'}}
            </span>
          </th>
          <th style="height: 40px;" class="th-upper">Current Value</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-log let-columns="columns">
        <tr [pSelectableRow]="log"
            [ngClass]="{'selectedDetail': log === selectedAppointmentDetail}"
        >
          <td>{{log}}</td>
          <td *ngIf="selectedEventLog"
              [ngClass]="{'difference' : currentDifference.indexOf(log) !== -1}">
              <span *ngIf="isDateParam(log) && selectedTimeZone === 'UTC'">
                {{ getEventValByParamName(log !== 'triggerTime' ? log + 'Ms' : log, 'event') |  amUtc |  amDateFormat:'YYYY-MM-DD[T]HH:mm:ss[Z]' }}
              </span>

              <span *ngIf="isDateParam(log) && selectedTimeZone !== 'UTC'">
                {{ getEventValByParamName(log !== 'triggerTime' ? log + 'Ms' : log, 'event') | amDateFormat:'MM/DD/YYYY h:mm a' }}
              </span>

              <span *ngIf="!isDateParam(log)">
                {{getEventValByParamName(log, 'event')}}
              </span>
          </td>
          <td *ngIf="eventsForSelectedMessage"
              [ngClass]="{'difference' : currentDifference.indexOf(log) !== -1}">

            <span *ngIf="isDateParam(log) && selectedTimeZone === 'UTC'">
                {{ getEventValByParamName(log !== 'triggerTime' ? log + 'Ms' : log, 'message') |  amUtc |  amDateFormat:'YYYY-MM-DD[T]HH:mm:ss[Z]' }}
              </span>

            <span *ngIf="isDateParam(log) && selectedTimeZone !== 'UTC'">
                {{ getEventValByParamName(log !== 'triggerTime' ? log + 'Ms' : log, 'message') | amDateFormat:'MM/DD/YYYY h:mm a' }}
              </span>

            <span *ngIf="!isDateParam(log)">
                {{getEventValByParamName(log, 'message')}}
              </span>
          </td>
          <td>
            <span *ngIf="isDateParam(log) && selectedTimeZone === 'UTC'">
                {{ selectedAppointment[log !== 'triggerTime' ? log + 'Ms' : log] |  amUtc |  amDateFormat:'YYYY-MM-DD[T]HH:mm:ss[Z]' }}
              </span>

            <span *ngIf="isDateParam(log) && selectedTimeZone !== 'UTC'">
                {{ selectedAppointment[log !== 'triggerTime' ? log + 'Ms' : log] | amDateFormat:'MM/DD/YYYY h:mm a' }}
            </span>

            <span *ngIf="log === 'triggerTime' && selectedTimeZone === 'UTC'">
                {{ this.getTriggerTimeAsTimeStamp(selectedAppointment) |  amUtc |  amDateFormat:'YYYY-MM-DD[T]HH:mm:ss[Z]' }}
            </span>

            <span *ngIf="log === 'triggerTime' && selectedTimeZone !== 'UTC'">
                {{ this.getTriggerTimeAsTimeStamp(selectedAppointment) | amDateFormat:'MM/DD/YYYY h:mm a'  }}
            </span>

            <span *ngIf="!isDateParam(log) && log !== 'triggerTime'">
               {{ selectedAppointment[log] }}
              </span>
          </td>

        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
